import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';


export const accountSearchResultParentAccountsSlice = getCachedTableDataSlice<
    Record<string, string>,
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResultParentAccounts');

export const accountSearchResultParentAccountsActions = accountSearchResultParentAccountsSlice.actions;

const accountSearchResultParentAccountsCacheSelector: CachedTableCacheSelector<Record<string, string>>
    = state => state.userPage.tabs.assignedAccounts.parentAccounts.cache;
export const accountSearchResultParentAccountsDataSelector: CachedTableDataSelector<Record<string, string>>
    = state => state.userPage.tabs.assignedAccounts.parentAccounts;
export const accountSearchResultParentAccountsResultSelector = getCachedTableResultSelector(
    accountSearchResultParentAccountsCacheSelector,
    accountSearchResultStateSelector,
);
